import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DISCOVER_SECTION_KEYS } from './discover/constants'
import { DiscoverSection } from './discover/DiscoverSection'
import { SectionContent } from './discover/sectionContents'

export function DiscoverPage() {
  const { t } = useTranslation()
  const [openIndices, setOpenIndices] = useState<Set<number>>(new Set([0]))

  const handleToggle = (index: number) => {
    setOpenIndices(prev => {
      const next = new Set(prev)
      if (next.has(index)) next.delete(index)
      else next.add(index)
      return next
    })
  }

  return (
    <div className="bg-background flex min-h-0 flex-1 flex-col items-center px-4 py-10">
      <div className="mx-auto w-full max-w-[1140px]">
        <h1 className="text-foreground mb-10 flex items-center justify-center text-2xl font-semibold">
          {t('discover.title')}
        </h1>

        <div className="bg-card border-border overflow-hidden rounded-[24px] border">
          {DISCOVER_SECTION_KEYS.map((sectionKey, index) => {
            const isLast = index === DISCOVER_SECTION_KEYS.length - 1
            const isOpen = openIndices.has(index)

            return (
              <DiscoverSection
                key={sectionKey}
                sectionLabel={t(sectionKey)}
                isOpen={isOpen}
                onToggle={() => handleToggle(index)}
                isLast={isLast}
              >
                <SectionContent index={index} sectionKey={sectionKey} />
              </DiscoverSection>
            )
          })}
        </div>
      </div>
    </div>
  )
}
